import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VendorChargingReportResponse } from '../../model/vendorReports';

export type VendorChargingReportState = {
  data: VendorChargingReportResponse | null;
  loading: boolean;
  error: string | null;
  downloadError: string | null;
  toggleValue: number;
};

const initialState: VendorChargingReportState = {
  data: null,
  loading: false,
  error: null,
  downloadError: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'vendorChargingReport',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<VendorChargingReportResponse>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    setDownloadError: (state, action: PayloadAction<string | null>) => {
      state.downloadError = action.payload;
    },
  },
});

export const vendorChargingReport = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed, setDownloadError } = slice.actions;
